/**
 * www.vleo.net's header animation :)
 *
 * @author Andrea Leofreddi
 */
let parent,
    scene,
    camera,
    renderer,
    composer,
    width,
    height,
    lgWidth,
    fadePass,
    phase = 0,
    cubes,
    lastUpdate = 0,
    bg = 0xffffff,
    fps = 25;

function init() {
    parent = document.getElementById('animation-parent');
    width = Math.min(parent.clientWidth, 1650);
    lgWidth = parent.clientWidth > 1550;
    height = Math.min(parent.clientHeight, width);

    scene = new THREE.Scene();
    initCamera();
    initRenderer();
    initCubes();
    parent.insertBefore(renderer.domElement, parent.firstChild);
}

function initCubes() {
    cubes = Array(Math.floor(height / 1040 * 20));
    for(let i = 0; i < cubes.length; i++) {
        cubes[i] = Array(Math.min(Math.floor((width - (lgWidth ? 100 : 0)) / 1040 * 16), 22));
        for(let j = 0; j < cubes[i].length; j++) {
            if(lgWidth && (
                ((j === 0 || j === cubes[i].length - 1) && i % 2 === 1)
                || ((j === 1 || j === cubes[i].length - 2) && i % 4 === 0)
            ))
                continue;

            cubes[i][j] = new THREE.Mesh(new THREE.CubeGeometry(2, 2, 2), new THREE.MeshNormalMaterial());
            cubes[i][j].translateX(2.8 * (j - (cubes[i].length - 1) / 2.0));
            cubes[i][j].translateY(-2.8 * i);
            scene.add(cubes[i][j]);
        }
    }
}

function rotateCube() {
    const speed = Math.PI / 30.0;
    for(let i = 0; i < cubes.length; i++) {
        for(let j = 0; j < cubes[i].length; j++) {
            if(!cubes[i][j])
                continue;
            cubes[i][j].rotation.x = speed * phase + (i + j * 2) / 10.0;
            cubes[i][j].rotation.y = speed * phase + (i + j * 2) / 10.0;
            cubes[i][j].rotation.z = speed * phase + (i + j * 2) / 10.0;
        }
    }
}

function initCamera() {
    const d = width / 512 * 10;
    camera = new THREE.OrthographicCamera(-d, d, 0, -d * 2 * (height / width), -100, 1000);
}

function initRenderer() {
    renderer = new THREE.WebGLRenderer({antialias: true});
    renderer.setSize(width, height);
    renderer.domElement.setAttribute("style", "position: absolute; margin-left: 50%; transform: translate(-50%, 0);");
    renderer.setClearColor(bg, 1);

    composer = new THREE.EffectComposer(renderer);
    composer.addPass(new THREE.RenderPass(scene, camera));
    composer.setSize(width, height);

    const fadeShader = {
        uniforms: {
            tDiffuse: {value: null},
            height: {value: height},
            fadeIn: {value: 1.0},
            bg: {type: 'vec3', value: new THREE.Color(bg)}
        },
        vertexShader: `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1);
}`,
        fragmentShader: `
varying vec2 vUv;
uniform sampler2D tDiffuse;
uniform vec3 color;
uniform vec3 bg;
uniform float height;
uniform float fadeIn;
void main() {
    vec4 previousPassColor = texture2D(tDiffuse, vUv);
    gl_FragColor = vec4(
        mix(bg, previousPassColor.rgb, fadeIn * (gl_FragCoord.y / height) * 0.7),
        previousPassColor.w
    );
}`,
    };
    fadePass = new THREE.ShaderPass(fadeShader);
    fadePass.renderToScreen = true;
    composer.addPass(fadePass);
}

function render() {
    requestAnimationFrame(render);
    let now = Date.now();
    if(now - lastUpdate > 1000 / fps) {
        lastUpdate = now;
        rotateCube();
        composer.render(phase);
        phase += 8.0 / fps;
        fadePass.uniforms.fadeIn.value = 1.0; //Math.min(phase / 10.0, 1.0);
    }
}

window.addEventListener('DOMContentLoaded', function() {
    init();
    render();
});

window.addEventListener('resize', function() {
    if(parent) {
        cancelAnimationFrame(render);
        parent.removeChild(renderer.domElement);
        parent = null;
    }
    init();
}, true);

